import 'phaser';
import {
  CST
} from "../CST";
import QuestionScene from './QuestionScene';
import StatementScene from './StatementScene';

import {
  data
} from 'jquery';

var clickSound;
var congratsSound;
var rollDiceSound;
var pawnMoveSound;
var pop;
var cont;
var graphics;
var piece;
var piece2;
var piece3;
var piece4;
var position;
var dice;
var turn;
var turn_piece;
var btn_roll_dice
var next_coordinate;
var next_coordinate2;
var next_coordinate3;
var next_coordinate4;
var start;
var start_magic;
var end_square;
var end;
var end2;
var replay;
var turn_cont;

var names = new Array();
var score = new Array();
var pointsText = new Array();
var magic = new Array();
var points = new Array();

export default class BoardScene4 extends Phaser.Scene {

  constructor() {
    super(CST.SCENES.BOARD4);
  }

  init() {
    turn_cont = 0;
    cont = 0;
    turn = 0;
    position = 0;
    start = true;
    start_magic = true;
    end = false;
    end2 = false;
    score = new Array();
    pointsText = new Array();
  }

  create(data) {
    for (let index = 0; index < data.data.length; index++) {
      switch (index) {
        case 0:
          if (data.data[index] == "")
            data.data[index] = "Gold Team";
          break;
        case 1:
          if (data.data[index] == "")
            data.data[index] = "Green Team";
          break;
        case 2:
          if (data.data[index] == "")
            data.data[index] = "Red Team";
          break;
        case 3:
          if (data.data[index] == "")
            data.data[index] = "Purple Team";
          break;
        default:
          break;
      }
    }

    names = data.data;
    replay = data.replay;

    clickSound = this.sound.add("clickSound", {
      volume: 0.5
    });
    congratsSound = this.sound.add("congratsSound");
    rollDiceSound = this.sound.add("rollDiceSound");
    pawnMoveSound = this.sound.add("pawnMoveSound", {
      volume: 0.5
    });
    pop = this.sound.add("popSound", {
      volume: 0.75
    });

    this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "board_background");

    graphics = this.add.graphics();

    next_coordinate = new Phaser.Math.Vector2(387, 819);
    next_coordinate2 = new Phaser.Math.Vector2(387, 819);
    next_coordinate3 = new Phaser.Math.Vector2(387, 819);
    next_coordinate4 = new Phaser.Math.Vector2(387, 819);

    // Normal and magic squares 

    var i = new Phaser.Math.Vector2(387, 819);
    points.push(i);
    i = new Phaser.Math.Vector2(423, 736);
    points.push(i);
    i = new Phaser.Math.Vector2(468, 662);
    points.push(i);
    i = new Phaser.Math.Vector2(511, 593);
    points.push(i);
    i = new Phaser.Math.Vector2(557, 525);
    points.push(i);
    magic.push(i);
    i = new Phaser.Math.Vector2(597, 443);
    points.push(i);
    i = new Phaser.Math.Vector2(625, 365);
    points.push(i);
    i = new Phaser.Math.Vector2(643, 283);
    points.push(i);
    i = new Phaser.Math.Vector2(607, 197);
    points.push(i);
    i = new Phaser.Math.Vector2(658, 121);
    points.push(i);
    i = new Phaser.Math.Vector2(756, 160);
    points.push(i);
    i = new Phaser.Math.Vector2(837, 238);
    points.push(i);
    magic.push(i);
    i = new Phaser.Math.Vector2(853, 328);
    points.push(i);
    i = new Phaser.Math.Vector2(844, 407);
    points.push(i);
    magic.push(i);
    i = new Phaser.Math.Vector2(838, 474);
    points.push(i);
    i = new Phaser.Math.Vector2(814, 558);
    points.push(i);
    i = new Phaser.Math.Vector2(805, 636);
    points.push(i);
    i = new Phaser.Math.Vector2(827, 725);
    points.push(i);
    magic.push(i);
    i = new Phaser.Math.Vector2(890, 801);
    points.push(i);
    i = new Phaser.Math.Vector2(951, 715);
    points.push(i);
    i = new Phaser.Math.Vector2(1043, 683);
    points.push(i);
    i = new Phaser.Math.Vector2(1069, 590);
    points.push(i);
    i = new Phaser.Math.Vector2(1103, 507);
    points.push(i);
    i = new Phaser.Math.Vector2(1150, 427);
    points.push(i);
    i = new Phaser.Math.Vector2(1226, 391);
    points.push(i);
    magic.push(i);
    i = new Phaser.Math.Vector2(1230, 309);
    points.push(i);
    i = new Phaser.Math.Vector2(1241, 228);
    points.push(i);
    i = new Phaser.Math.Vector2(1248, 125);
    points.push(i);
    i = new Phaser.Math.Vector2(1372, 181);
    points.push(i);
    end_square = i;

    // Rules button

    this.add.image(167, 825, "btn_rules2").setScale(1.3).setInteractive({
      useHandCursor: true
    }).on('pointerdown', () => {
      this.scene.pause();
      this.scene.launch(CST.SCENES.RULES1, {
        scene: CST.SCENES.BOARD4,
      });
    })

    var flag = this.add.image(185, 650, "flag");

    // Pawns and right hand side layout

    piece = this.add.image(387, 819, 'yellow_piece').setScale(.75);
    piece2 = this.add.image(387, 819, 'green_piece').setScale(.75);
    piece3 = this.add.image(387, 819, 'red_piece').setScale(.75);
    piece4 = this.add.image(387, 819, 'purple_piece').setScale(.75);

    this.add.image(250, 80, "team_name_box_yellow").setScale(.4);
    this.add.text(170, 69, data.data[0], CST.TEXTSTYLES.TEAMNAME);
    score.push(0);
    pointsText.push(this.add.text(375, 71, " " + score[0].toString(), CST.TEXTSTYLES.POINTS));

    this.add.image(250, 180, "team_name_box_green").setScale(.4);
    this.add.text(170, 169, data.data[1], CST.TEXTSTYLES.TEAMNAME);
    score.push(0);
    pointsText.push(this.add.text(375, 171, " " + score[1].toString(), CST.TEXTSTYLES.POINTS));

    this.add.image(250, 280, "team_name_box_red").setScale(.4);
    this.add.text(170, 269, data.data[2], CST.TEXTSTYLES.TEAMNAME);
    score.push(0);
    pointsText.push(this.add.text(375, 271, " " + score[2].toString(), CST.TEXTSTYLES.POINTS));

    this.add.image(250, 380, "team_name_box_purple").setScale(.4);
    this.add.text(170, 369, data.data[3], CST.TEXTSTYLES.TEAMNAME);
    score.push(0);
    pointsText.push(this.add.text(375, 371, " " + score[3].toString(), CST.TEXTSTYLES.POINTS));

    //Creating dice's spritesheet, roll dice button and animation

    dice = this.add.sprite(1400, 825, 'dice');

    btn_roll_dice = this.add.image(1225, 825, 'btn_roll_dice').setScale(0.6);
    btn_roll_dice.setInteractive({
      useHandCursor: true
    });
    btn_roll_dice.on('pointerdown', this.rollDice);

    this.anims.create({
      key: 'dice_roll',
      frames: this.anims.generateFrameNames('dice_rolling'),
      frameRate: 8,
      repeat: 1
    });

    var discussion1 = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'd1').setVisible(false);
    var discussion2 = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'd2').setVisible(false);
    var discussion3 = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'd3').setVisible(false);
    var discussion4 = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'd4').setVisible(false);
    var discussion5 = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'd5').setVisible(false);

    var next = this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2) + 336, 'btn_next').setVisible(false);
    next.setInteractive({
      useHandCursor: true
    });
    next.on("pointerdown", () => {
      clickSound.play();
      next.setVisible(false);
      discussion1.setVisible(false);
      discussion2.setVisible(false);
      discussion3.setVisible(false);
      discussion4.setVisible(false);
      discussion5.setVisible(false);
      btn_roll_dice.setTexture("btn_roll_dice");
      btn_roll_dice.setInteractive({
        useHandCursor: true
      });
    });

    this.events.on("resume", (e, t) => {
      if (t.type == 0) {
        if (t.data == 0) {
          switch (turn) {
            case 0:
              flag.setFrame(0);
              score[3] = score[3] + t.points;
              score[3] >= 10 ? pointsText[3].text = score[3] : pointsText[3].text = " " + score[3];
              break;
            case 1:
              flag.setFrame(1);
              score[0] = score[0] + t.points;
              score[0] >= 10 ? pointsText[0].text = score[0] : pointsText[0].text = " " + score[0];
              break;
            case 2:
              flag.setFrame(2);
              score[1] = score[1] + t.points;
              score[1] >= 10 ? pointsText[1].text = score[1] : pointsText[1].text = " " + score[1];
              break;
            case 3:
              flag.setFrame(3);
              score[2] = score[2] + t.points;
              score[2] >= 10 ? pointsText[2].text = score[2] : pointsText[2].text = " " + score[2];
              break;
            default:
              break;
          }
        }

        switch (turn_cont) {
          case 2:
            showDiscussion(next, discussion1);
            break;
          case 6:
            showDiscussion(next, discussion2);
            break;
          case 9:
            showDiscussion(next, discussion3);
            break;
          case 12:
            showDiscussion(next, discussion4);
            break;
          case 14:
            showDiscussion(next, discussion5);
            break;
          default:
            btn_roll_dice.setTexture("btn_roll_dice");
            btn_roll_dice.setInteractive({
              useHandCursor: true
            });
            break;
        }
      } else if (t.type == 1){
        movePiece(this, t.direction, t.squares);
      }

      if (t.end) {
        const black_screen = this.add.image(0, 0, 'black_screen');
        var popup = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "pop_up_end");
        black_screen.setAlpha(0.5);
        black_screen.setScale(3);
        setTimeout(() => {
          popup.setVisible(false);
          black_screen.setVisible(false);
          endGame(this);
        }, 3000);
      }
    });
  }

  update() {

    /*graphics.clear();

    graphics.lineStyle(2, 0x000000, 3);
    graphics.fillStyle(0x000000, 1);

    for (var i = 0; i < points.length; i++) {
      graphics.fillStyle(0x00ff00, 1);
      graphics.fillCircle(points[i].x, points[i].y, 8);
    }

    for (var i = 0; i < magic.length; i++) {
      graphics.fillStyle(0x00ffff, 1);
      graphics.fillCircle(magic[i].x, magic[i].y, 8);
    }*/

    //var pointer = this.input.activePointer;

    /*if (pointer.isDown) {
      console.log(pointer.x);
      console.log(pointer.y);
    }*/

    // End Screen
    if (!end2) {
      if (piece.x == end_square.x && piece.y == end_square.y) {
        end2 = true;
        score[0] = score[0] + 3;
        score[0] >= 10 ? pointsText[0].text = score[0] : pointsText[0].text = " " + score[0];
        endGame(this);
      } else if (piece2.x == end_square.x && piece2.y == end_square.y) {
        end2 = true;
        score[1] = score[1] + 3;
        score[1] >= 10 ? pointsText[1].text = score[1] : pointsText[1].text = " " + score[1];
        endGame(this);
      } else if (piece3.x == end_square.x && piece3.y == end_square.y) {
        end2 = true;
        score[2] = score[2] + 3;
        score[2] >= 10 ? pointsText[2].text = score[2] : pointsText[2].text = " " + score[2];
        endGame(this);
      } else if (piece4.x == end_square.x && piece4.y == end_square.y) {
        end2 = true;
        score[3] = score[3] + 3;
        score[3] >= 10 ? pointsText[3].text = score[3] : pointsText[3].text = " " + score[3];
        endGame(this);
      }
    }
  }

  rollDice() {
    clickSound.play();
    rollDiceSound.play();
    dice.play("dice_roll");
    btn_roll_dice.disableInteractive();
    btn_roll_dice.setTexture('btn_roll_dice_bw')
    var scene = this;
    setTimeout(function () {
      nextPath(scene);
    }, 1500);
  }
}

function nextPath(scene) {
  switch (turn) {
    case 0:
      turn_piece = next_coordinate;
      break;
    case 1:
      turn_piece = next_coordinate2;
      break;
    case 2:
      turn_piece = next_coordinate3;
      break;
    case 3:
      turn_piece = next_coordinate4;
      break;
    default:
      break;
  }

  var min = Math.ceil(1);
  var max = Math.floor(6);
  var rndNum = Math.floor(Math.random() * (max - min + 1)) + min;

  dice.setTexture("dice", rndNum - 1);

  for (var i = 0; i < points.length; i++) {
    if (points[i].equals(turn_piece)) {
      position = i;
      break;
    }
  }

  var nextcell = (position + rndNum);

  if (nextcell >= 29) {
    turn_piece = end_square;
    end = true;
  } else {
    turn_piece = points[nextcell];
  }

  var timeout = nextcell - position;

  switch (turn) {
    case 0:
      next_coordinate = turn_piece;
      choosePiece(scene, 1, next_coordinate, piece, nextcell, timeout, "Forward", true);
      break;
    case 1:
      next_coordinate2 = turn_piece;
      choosePiece(scene, 2, next_coordinate2, piece2, nextcell, timeout, "Forward", true);
      break;
    case 2:
      next_coordinate3 = turn_piece;
      choosePiece(scene, 3, next_coordinate3, piece3, nextcell, timeout, "Forward", true);
      break;
    case 3:
      next_coordinate4 = turn_piece;
      choosePiece(scene, 0, next_coordinate4, piece4, nextcell, timeout, "Forward", true);
      break;
    default:
      break;
  }
}

function choosePiece(scene, nextTurn, coordinate, pieceToMove, nextcell, timeout, direction, showQuestion) {
  turn = nextTurn;
  var count = -1;
  if (direction == "Forward") {
    for (var j = position; j <= nextcell; j++) {
      count++;
      doSetTimeout(scene, pieceToMove, count, j, showQuestion);
    }
  } else {
    for (var j = position; j >= nextcell; j--) {
      count++;
      doSetTimeout(scene, pieceToMove, count, j, showQuestion);
    }
  }

  if (showQuestion) {
    setTimeout(() => {
      checkSquare(coordinate, scene, pieceToMove);
    }, timeout * 400);
  }
}

function doSetTimeout(scene, pieceToMove, timeout, i, showQuestion) {
  if (showQuestion) {
    setTimeout(() => {
      scene.scene.tweens.add({
        targets: pieceToMove,
        x: {
          value: points[i].x,
          duration: 300
        },
        y: {
          value: points[i].y,
          duration: 300
        },
      });
      if (timeout != 0) pawnMoveSound.play();
    }, timeout * 400);
  } else {
    setTimeout(() => {
      scene.scene.scene.tweens.add({
        targets: pieceToMove,
        x: {
          value: points[i].x,
          duration: 300
        },
        y: {
          value: points[i].y,
          duration: 300
        },
      });
      if (timeout != 0) pawnMoveSound.play();
    }, timeout * 400);
  }
}

function checkSquare(x, scene, pieceToMove) {
  var magic_square = false;

  for (var t = 0; t < magic.length; t++) {
    if (magic[t].x == x.x && magic[t].y == x.y) {
      magic_square = true;
    }
  }

  if (!end) {
    if (magic_square) {
      showStatement(scene);
    } else {
      showQuestion(scene);
    }
  }
}

function movePiece(scene, direction, squares) {
  switch (turn) {
    case 0:
      turn_piece = next_coordinate4;
      break;
    case 1:
      turn_piece = next_coordinate;
      break;
    case 2:
      turn_piece = next_coordinate2;
      break;
    case 3:
      turn_piece = next_coordinate3;
      break;
    default:
      break;
  }

  for (var i = 0; i < points.length; i++) {
    if (points[i].equals(turn_piece)) {
      position = i;
      break;
    }
  }

  var coordinate = (direction == "Forward") ? position + parseInt(squares) : position - parseInt(squares);

  if (coordinate >= 29) {
    turn_piece = end_square;
    end = true;
  } else {
    turn_piece = points[coordinate];
  }

  var timeout = coordinate - position;

  switch (turn) {
    case 0:
      next_coordinate4 = turn_piece;
      choosePiece(scene, 0, next_coordinate4, piece4, coordinate, timeout, direction, false);
      break;
    case 1:
      next_coordinate = turn_piece;
      choosePiece(scene, 1, next_coordinate, piece, coordinate, timeout, direction, false);
      break;
    case 2:
      next_coordinate2 = turn_piece;
      choosePiece(scene, 2, next_coordinate2, piece2, coordinate, timeout, direction, false);
      break;
    case 3:
      next_coordinate3 = turn_piece;
      choosePiece(scene, 3, next_coordinate3, piece3, coordinate, timeout, direction, false);
      break;
    default:
      break;
  }
}

function showQuestion(scene) {
  turn_cont++;
  setTimeout(function () {
    pop.play();

    scene.scene.scene.pause();

    if (start) {
      scene.scene.scene.launch(CST.SCENES.QUESTION, {
        scene: CST.SCENES.BOARD4,
        replay: replay
      });
      start = false;
    } else {
      scene.scene.scene.resume(CST.SCENES.QUESTION, {
        scene: CST.SCENES.BOARD4,
      });
    }

    scene.scene.scene.bringToTop(CST.SCENES.QUESTION);
  }, 1000)
}

function showStatement(scene) {
  setTimeout(function () {
    pop.play();

    btn_roll_dice.setTexture("btn_roll_dice");
    btn_roll_dice.setInteractive({
      useHandCursor: true
    });

    scene.scene.scene.pause();

    if (start_magic) {
      scene.scene.scene.launch(CST.SCENES.STATEMENT, {
        scene: CST.SCENES.BOARD4,
        replay: replay
      });
      start_magic = false;
    } else {
      scene.scene.scene.resume(CST.SCENES.STATEMENT, {
        scene: CST.SCENES.BOARD4,
      });
    }

    scene.scene.scene.bringToTop(CST.SCENES.STATEMENT);
  }, 1000)
}

function showDiscussion(next, discussion) {
  setTimeout(() => {
    pop.play();
    next.setVisible(true);
    discussion.setVisible(true);
  }, 2500);
}

function endGame(scene) {
  congratsSound.play();

  scene.anims.create({
    key: 'firework-blue',
    frames: scene.anims.generateFrameNames('firework-blue'),
    frameRate: 30,
    repeat: -1
  });

  scene.anims.create({
    key: 'firework-yellow',
    frames: scene.anims.generateFrameNames('firework-yellow'),
    frameRate: 30,
    repeat: -1
  });

  var firework_blue = scene.add.sprite(1000, 500, 'firework-blue');
  firework_blue.play('firework-blue');
  var firework_yellow = scene.add.sprite(600, 300, 'firework-yellow');
  firework_yellow.play('firework-yellow');


  setTimeout(() => {
    var firework_blue2 = scene.add.sprite(300, 100, 'firework-blue');
    firework_blue2.play('firework-blue');
  }, 500);

  setTimeout(() => {
    firework_yellow = scene.add.sprite(900, 750, 'firework-yellow');
    firework_yellow.play('firework-yellow');
  }, 550);

  setTimeout(() => {
    firework_blue = scene.add.sprite(275, 400, 'firework-blue');
    firework_blue.play('firework-blue');
  }, 850);

  setTimeout(() => {
    firework_yellow = scene.add.sprite(100, 750, 'firework-yellow');
    firework_yellow.play('firework-yellow');
  }, 900);

  setTimeout(() => {
    firework_blue = scene.add.sprite(1175, 150, 'firework-blue');
    firework_blue.play('firework-blue');
  }, 1100);

  setTimeout(() => {
    restartGame(scene);
  }, 3000);
}


function restartGame(scene) {
  var array = new Array();

  for (let index = 0; index < names.length; index++) {
    array.push([names[index], score[index]]);
  }

  array.sort(sortFunction);

  scene.scene.remove(CST.SCENES.QUESTION);
  scene.scene.add(CST.SCENES.QUESTION, QuestionScene, false);
  scene.scene.remove(CST.SCENES.STATEMENT);
  scene.scene.add(CST.SCENES.STATEMENT, StatementScene, false);
  scene.scene.stop(CST.SCENES.BOARD4);
  scene.scene.launch(CST.SCENES.ENDSCREEN, {
    scene: CST.SCENES.BOARD4,
    names: names,
    array: array
  });
}

function sortFunction(a, b) {
  if (a[1] === b[1]) {
    return 0;
  } else {
    return (a[1] > b[1]) ? -1 : 1;
  }
}